var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-news-stories"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-news-stories__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-news-stories__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb7cb11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-news-stories/page-news-stories.vue
// module id = xdho
// module chunks = 0